module.exports = __webpack_public_path__ + "img/04.5894fd27.png";